var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgApple = function SvgApple(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#apple_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.246 7.024C13 7 14.13 6.273 14.75 5.5c.563-.7.941-1.647.941-2.626 0-.132-.011-.265-.035-.374-.926.036-1.988.69-2.656 1.5-.527.616-1 2-1.035 2.662-.008.145.023.29.035.338.059.012.152.027.246.024ZM9 21.5c1.137 0 1.582-.5 3-.5 1.441 0 2.234.5 3.5.5 1.242 0 1.95-1.34 2.734-2.5.88-1.329 1.243-2.44 1.266-2.5-.082-.024-2.5-1.186-2.5-4 0-2.44 2.395-3.415 2.5-3.5-1.242-1.836-3.484-2-4-2-1.395 0-2.785 1-3.5 1-.773 0-1.793-1-3-1-2.297 0-4.5 1.804-4.5 5.5 0 2.295.934 4.93 2 6.5 0 0 1.5 2.5 2.5 2.5Z",
    fill: "#000",
    opacity: 0.84
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "apple_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgApple;